import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { omit } from 'underscore';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import cx from 'classnames';
import URI from 'urijs';

// components
import Paginator from '../../components/paginator/paginator';

// ducks
import { paginateThis, sortFields, MEMBER_TYPE_MAP } from '../../ducks/OfficeSearch';

// middleware
import { cleanQuery } from '../../middleware/client';

// containers
import OfficeSearchResults from './OfficeSearchResults';
import OfficeSearchForm from './OfficeSearchForm';
// import OfficeSearchFilterModal from "./OfficeSearchFilterModal";

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

class OfficeSearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    const {
      query,
      location: { pathname }
    } = this.props;
    const { handleChange, handleSubmit } = this;
    const initialValues = omit(query, 'page', 'pageSize');
    const linkQuery = cleanQuery(query);
    const officeType = initialValues.officeType || this.props.officeType;
    const searchTo = URI(this.props.pathname)
      .search({
        officeType: officeType !== 'brokerage' ? officeType : undefined
      })
      .toString();

    return (
      <Container fluid className={styles.OfficeSearch}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to={searchTo}>
                <BreadcrumbItem active>
                  Find a {MEMBER_TYPE_MAP[officeType].label}
                </BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <OfficeSearchForm
          enableReinitialize={true}
          initialValues={initialValues}
          onFilterClick={() => {
            this.setState({
              showModal: true
            });
          }}
          onChange={handleChange}
          onSubmit={handleSubmit}
          basePath={pathname}
        />

        <Row className={cx(styles.searchPagination, BS.pt3)}>
          <Container>
            <Paginator
              listId="offices"
              to={pathname}
              query={linkQuery}
              sortFields={sortFields}
              top
            />
          </Container>
        </Row>
        <OfficeSearchResults listId="offices" />
        <Row className={cx(styles.searchPagination, BS.pt3)}>
          <Container>
            <Paginator
              listId="offices"
              to={pathname}
              query={linkQuery}
              sortFields={sortFields}
              bottom
            />
          </Container>
        </Row>
      </Container>
    );
  }

  handleChange(values, dispatch, props, previousValues) {
    clearTimeout(this.onChangeSubmitTimeout);
    if (!props.pristine) {
      this.onChangeSubmitTimeout = setTimeout(() => {
        props.submit();
      }, 100);
    }
  }

  handleSubmit(values, dispatch, props) {
    const {
      submitSearch,
      location: { pathname }
    } = this.props;

    return submitSearch({
      to: pathname,
      values: values
    });
  }

  componentWillUnmount() {
    this.props.clearResults();
  }

  componentDidUpdate(prevProps) {
    const prevPathname = prevProps.location.pathname,
      pathname = this.props.location.pathname,
      officeType = this.props.query.officeType,
      oldOfficeType = prevProps.query.officeType;

    if (this.props.query.page !== prevProps.query.page) {
      window.scrollTo(0, 0);
    }

    if (oldOfficeType !== officeType) {
      this.props.resetResults([]);
    }

    if (
      prevPathname === this.props.pathnameAdvanced &&
      (pathname === this.props.pathnameAdvancedResults ||
        pathname === this.props.pathname)
    ) {
      this.props.expire();
    }
  }
}

const OfficeSearchDecorated = paginateThis.decorate(OfficeSearch, (state, props) => {
  return {
    officeType: props.officeType,
    name: ''
  };
});

OfficeSearchDecorated.defaultProps = {
  pathname: '/find-naples-firm',
  pathnameAdvanced: '/find-naples-firm/advanced',
  pathnameAdvancedResults: '/find-naples-firm/advanced/results',
  officeType: 'brokerage'
};

export default OfficeSearchDecorated;



// WEBPACK FOOTER //
// ./src/containers/OfficeSearch/OfficeSearch.js